import { apiServer } from "../../../api";
import { ILogPremium } from "../types";

export const LogsApi = {
  obterLogsCliente: async (
    clienteID: string,
    token: string,
    params: {
      q?: string;
      severidade?: string;
      dataInicial?: string;
      dataFinal?: string;
      limit?: number;
      offset?: number;
    }
  ) => {
    let url = `v2/logs/cliente/${clienteID}?limit=${params.limit ?? 20}&offset=${params.offset ?? 0}`;
    if (params.q) {
      url += `&q=${encodeURIComponent(params.q)}`;
    }
    if (params.severidade) {
      url += `&severidade=${encodeURIComponent(params.severidade)}`;
    }
    if (params.dataInicial) {
      url += `&dataInicial=${encodeURIComponent(params.dataInicial)}`;
    }
    if (params.dataFinal) {
      url += `&dataFinal=${encodeURIComponent(params.dataFinal)}`;
    }

    const response = await apiServer<{ items: ILogPremium[]; total: number }>().get(
      url,
      token
    );
    return response.data;
  },

  obterLogsTarefa: async (
    tarefaAgendadaID: string,
    token: string,
    params: {
      q?: string;
      severidade?: string;
      dataInicial?: string;
      dataFinal?: string;
      limit?: number;
      offset?: number;
    }
  ) => {
    let url = `v2/logs/tarefa/${tarefaAgendadaID}?limit=${params.limit ?? 20}&offset=${params.offset ?? 0}`;
    if (params.q) {
      url += `&q=${encodeURIComponent(params.q)}`;
    }
    if (params.severidade) {
      url += `&severidade=${encodeURIComponent(params.severidade)}`;
    }
    if (params.dataInicial) {
      url += `&dataInicial=${encodeURIComponent(params.dataInicial)}`;
    }
    if (params.dataFinal) {
      url += `&dataFinal=${encodeURIComponent(params.dataFinal)}`;
    }

    const response = await apiServer<{ items: ILogPremium[]; total: number }>().get(
      url,
      token
    );
    return response.data;
  },

  obterLogsHistorico: async (
    historicoTarefaAgendadaID: string,
    token: string,
    params: {
      q?: string;
      severidade?: string;
      dataInicial?: string;
      dataFinal?: string;
      limit?: number;
      offset?: number;
    }
  ) => {
    let url = `v2/logs/historico/${historicoTarefaAgendadaID}?limit=${params.limit ?? 20}&offset=${params.offset ?? 0}`;
    if (params.q) {
      url += `&q=${encodeURIComponent(params.q)}`;
    }
    if (params.severidade) {
      url += `&severidade=${encodeURIComponent(params.severidade)}`;
    }
    if (params.dataInicial) {
      url += `&dataInicial=${encodeURIComponent(params.dataInicial)}`;
    }
    if (params.dataFinal) {
      url += `&dataFinal=${encodeURIComponent(params.dataFinal)}`;
    }

    const response = await apiServer<{ items: ILogPremium[]; total: number }>().get(
      url,
      token
    );
    return response.data;
  }
};
